import { Provider } from '@angular/core';
import { AbstractTemporaryFileService } from '../../services/abstract-temporary-file/abstract-temporary-file.service';

export const provideTemporaryFileService = (
    implementation: typeof AbstractTemporaryFileService,
): Provider => ({
    provide: AbstractTemporaryFileService,
    useExisting: implementation,
});
